// import React, { useEffect, useState } from "react"
// import { useSelector } from "react-redux"
// import { Navigate } from "react-router"
// import { Loader } from "@components/Loader"
// import { protectedService } from "@services/authentication/protected"

// const ProtectedRoute = ({ children }) => {
//     const { authToken, isRetrieveTokenLoading } = useSelector(
//         (state) => state.auth
//     )
//     const [isVerifying, setIsVerifying] = useState(true)
//     const [isAuthenticated, setIsAuthenticated] = useState(false)

//     useEffect(() => {
//         const verifyAuth = async () => {
//             if (isRetrieveTokenLoading) return

//             try {
//                 await protectedService()
//                 setIsAuthenticated(true)
//             } catch (error) {
//                 setIsAuthenticated(false)
//             } finally {
//                 setIsVerifying(false)
//             }
//         }

//         verifyAuth()
//     }, [isRetrieveTokenLoading])

//     if (isRetrieveTokenLoading || isVerifying) {
//         return <Loader />
//     }

//     if (!authToken || !isAuthenticated) {
//         return <Navigate to="/sign-in" replace />
//     }

//     return children
// }

// export default ProtectedRoute


import { protectedService } from "@services/authentication/protected"
import { Navigate } from "react-router"
import { Loader } from "@components/Loader"
import { useState, useEffect } from "react"

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        await protectedService()
        setIsAuthenticated(true)
      } catch (error) {
        setIsAuthenticated(false)
      }
    }
    verifyAuth()
  }, [])

  if (isAuthenticated === null) {
    return <Loader />
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in?onboarding=true" replace />
  }

  return children
}

export default ProtectedRoute

